import angular from 'angular';
import { DynamicStyleController } from './DynamicStyle.controller';
import './DynamicStyle.scss';

export const dynamicStyleModule = angular
  .module('bit.components.DynamicStyle', [])
  .controller('DynamicStyleController', DynamicStyleController)
  .directive('bitDynamicStyles', () => ({
    restrict: 'E',
    controller: 'DynamicStyleController',
    controllerAs: 'styles',
    scope: true,
    compile(tElement) {
      const content = tElement
        .html()
        .replace(/("|'){{/g, '{{')
        .replace(/}}("|')/g, '}}');
      tElement.html(`<style>${content}</style>`);
      return () => undefined;
    },
  }));
